"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
//
var isBrowser = (typeof window === "undefined" ? "undefined" : _typeof(window)) !== "undefined";
var getScrollPosition = function getScrollPosition(_ref) {
  var element = _ref.element;
  if (!isBrowser) return 0;
  var target = element !== null && element !== void 0 && element.current ? element.current : document.body;
  var position = target.scrollTop;
  return position;
};
var useElementScroll = function useElementScroll(_ref2) {
  var ref = _ref2.ref,
    _ref2$useWindow = _ref2.useWindow,
    useWindow = _ref2$useWindow === void 0 ? true : _ref2$useWindow,
    onChange = _ref2.onChange,
    onScrollToBottom = _ref2.onScrollToBottom,
    deps = _ref2.deps,
    wait = _ref2.wait;
  var position = (0, _react.useRef)(getScrollPosition({
    useWindow: useWindow
  }));
  var throttleTimeout = null;
  var callback = function callback() {
    var currentPosition = getScrollPosition({
      element: ref,
      useWindow: useWindow
    });
    if (ref.current) {
      var _ref$current, _ref$current2, _ref$current3;
      if (((_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.scrollHeight) - ((_ref$current2 = ref.current) === null || _ref$current2 === void 0 ? void 0 : _ref$current2.scrollTop) === ((_ref$current3 = ref.current) === null || _ref$current3 === void 0 ? void 0 : _ref$current3.clientHeight)) onScrollToBottom === null || onScrollToBottom === void 0 ? void 0 : onScrollToBottom();
    }
    onChange === null || onChange === void 0 ? void 0 : onChange(currentPosition);
    position.current = currentPosition;
    throttleTimeout = null;
  };
  (0, _react.useLayoutEffect)(function () {
    var handleScroll = function handleScroll(e) {
      if (wait) {
        if (throttleTimeout === null) {
          throttleTimeout = setTimeout(callback, wait);
        }
      } else {
        callback();
      }
    };
    if (ref.current) {
      ref.current.addEventListener('scroll', handleScroll);
    } else {
      window.addEventListener('scroll', handleScroll);
    }
    return function () {
      if (ref.current) {
        ref.current.removeEventListener('scroll', handleScroll);
      } else {
        window.removeEventListener('scroll', handleScroll);
      }
    };
  }, deps);
};
var _default = useElementScroll;
exports["default"] = _default;